<div class="modal-title dialog-title">{{title | i18nv2 }}</div>
<div class="modal-body dialog-content">
    <div class="clipboard-help-dialog-content selectable">{{ msg | i18nv2 : modKey : modKey : modKey : modKey }}</div>
    <!--<div class="clipboard-help-dialog-content selectable">{{msg | i18nv2}}</div>-->
</div>
<div class="modal-footer dialog-button-row">
    <button type="button" ngbAutofocus id="closeHelpBtn" class="modal-button-base modal-button-right modal-button-blue" (click)="closeModal()">
        {{ 'OK' | i18nv2 }}
    </button>
</div>